import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { MessageCircle, Phone, Mail } from 'lucide-react';
import { useState } from 'react';
import ChatBot from '../common/ChatBot';

const ContactSupport = () => {
  const [isChatOpen, setIsChatOpen] = useState(false);
  const handleEmailClick = () => {
    const email = 'support@forexcrm.com';
    const subject = 'Support Request';
    window.open(
      `mailto:${email}?subject=${encodeURIComponent(subject)}`,
      '_blank'
    );
  };

  const handlePhoneClick = () => {
    const phoneNumber = '+18001234501';
    window.open(`tel:${phoneNumber}`, '_blank');
  };

  return (
    <>
      <Card className="bg-primary/5 border-primary/20">
        <CardHeader>
          <CardTitle className="text-center">Still Need Help?</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="text-center space-y-4">
            <p className="text-muted-foreground">
              Cannot find what you are looking for? Our support team is here to
              help.
            </p>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div
                className="text-center space-y-2 cursor-pointer hover:bg-primary/5 p-3 rounded-lg transition-colors"
                onClick={handleEmailClick}
              >
                <div className="mx-auto p-3 bg-primary/10 rounded-full w-fit">
                  <Mail className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <div className="font-semibold">Email Support</div>
                  <div className="text-sm text-muted-foreground">
                    support@forexcrm.com
                  </div>
                </div>
              </div>
              <div
                className="text-center space-y-2 cursor-pointer hover:bg-primary/5 p-3 rounded-lg transition-colors"
                onClick={handlePhoneClick}
              >
                <div className="mx-auto p-3 bg-primary/10 rounded-full w-fit">
                  <Phone className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <div className="font-semibold">Phone Support</div>
                  <div className="text-sm text-muted-foreground">
                    +1-800-12345-01
                  </div>
                </div>
              </div>
              <div
                className="text-center space-y-2 cursor-pointer hover:bg-primary/5 p-3 rounded-lg transition-colors"
                onClick={() => setIsChatOpen(true)}
              >
                <div className="mx-auto p-3 bg-primary/10 rounded-full w-fit">
                  <MessageCircle className="h-6 w-6 text-primary" />
                </div>
                <div>
                  <div className="font-semibold">Live Chat</div>
                  <div className="text-sm text-muted-foreground">
                    Available 24/7
                  </div>
                </div>
              </div>
            </div>
            <Button
              className="mx-auto mt-6"
              onClick={() => setIsChatOpen(true)}
            >
              <MessageCircle className="h-4 w-4 mr-2" />
              Start Live Chat
            </Button>
          </div>
        </CardContent>
      </Card>
      <ChatBot open={isChatOpen} onOpenChange={setIsChatOpen} />
    </>
  );
};

export default ContactSupport;
